<template>
  <div id="wrap">
    <loading :active.sync="isLoading" color="#0868f1" background-color="#f5f5f5" loader="dots" :height="100" :width="100" inert></loading>
    <div v-if="isBanner && districtInfo.code === 'C'" class="commp4 tac banner-block">
      <div class="banner-dev">
        <a href="https://main.gyeonggi.platform.denti-i.com/login">
          현재 페이지는 시범 사이트로 <span style="color: red">{{ bannerText.before }}까지만 테스트 계정으로 로그인</span>할 수 있습니다.<br />
          {{ bannerText.after }}사업 오픈일 이후 정식 사이트를 이용해 주세요.<span class="c_blue underline ml10">덴티아이(Denti-i) 바로가기</span>
        </a>
        <!-- <div v-else-if="showInfoBanner" class="flex">
          <div>학교는 <span style="color: red">4/4(목)</span>부터, 교육(지원)청 및 의료기관은 <span style="color: red">4/8(월)</span>부터 로그인 가능합니다.</div>
        </div>
        <div v-else>
          {{ businessYear }}년 덴티아이 서비스는 12월 31일까지만 이용 가능합니다.<br />
          <span style="color: red">{{ businessYear + 1 }}년 1월 1일부로 접속 불가</span>하니 참고 바랍니다.
        </div> -->
        <button @click="isBanner = false"><img src="@/assets/images/common/ic_close.png" alt="다시 보지 않기" /></button>
      </div>
    </div>
    <v-header></v-header>
    <div id="container">
      <div v-if="!isOk" class="browser__page content__area">잠시만 기다려주세요.</div>
      <router-view v-else></router-view>
      <v-popup v-if="view"></v-popup>
    </div>
    <v-footer v-if="!$route.path.startsWith('/app/')"></v-footer>
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';
import Popup from '@/components/popup/Popup.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters, mapState } from 'vuex';
import Common from '@/apis/Common';
import Admin from '@/apis/Admin';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';

export default {
  data() {
    return {
      isBanner: false,
      // showInfoBanner: false,
    };
  },
  components: {
    'v-header': Header,
    'v-footer': Footer,
    'v-popup': Popup,
    Loading,
  },
  computed: {
    ...mapState(['isOk', 'isLoading']),
    ...mapState('popup', ['view']),
    ...mapState('business', ['businessYear']),
    ...mapGetters('business', ['districtInfo']),
    bannerText() {
      const beforeDate = new Date(this.districtInfo.startDay.replaceAll('-', '/'));
      beforeDate.setDate(beforeDate.getDate() - 1);
      const afterDate = new Date(this.districtInfo.startDay.replaceAll('-', '/'));
      return {
        before: this.convertBannerDateText(beforeDate),
        after: this.convertBannerDateText(afterDate),
      };
    },
  },
  created() {
    this.isBanner = this.isRel;
    Common.getIp().then(res => {
      this.$store.commit('ip/setIp', res.data);
      if (!res.data) return;
      Admin.authIp({
        ip: res.data,
      }).then(res => {
        if (!res) return;
        this.$store.commit('ip/setIsAlmighty', res.data?.valid || false);
      });
    });
    ChannelService.loadScript();
    ChannelService.boot({
      pluginKey: '32db7ca8-198f-43bd-871e-4e9c37fb3f44',
    });
  },
  methods: {
    convertBannerDateText(date) {
      const weekday = ['일', '월', '화', '수', '목', '금', '토'];
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}(${weekday[date.getDay()]})`;
    },
  },
};
</script>

<style lang="scss">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.login__page {
  @include box-sizing(border-box);

  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;

  #container {
    background-color: #fff !important;
  }

  #container,
  .container_wrap {
    height: 100%;
  }

  .login__con {
    width: auto;
    margin: 0 auto;
  }

  .login_form {
    width: 340px;
    max-width: 340px;
    margin: 0 auto;
  }

  .banner-block ~ #container {
    height: calc(100% - 80px);
  }

  .comm_put {
    @include border-radius(3px);
  }

  .f_link a {
    color: #2699fb;
    border-color: #2699fb;
  }

  #footer {
    border-top: 1px solid #dbdbdb;
  }
}

.banner-block {
  background-color: #fff7e1;
  height: 80px;
}

.banner-dev {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  height: 80px;
  line-height: 30px;

  & > a,
  & > div {
    position: absolute;
    padding: 10px 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    font-weight: 1000;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & > button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 25px;
    right: 0;
  }
}

/* tooltip */
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  @include border-radius(16px);

  background: black;
  color: white;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^='top'] {
  margin-bottom: 5px;
}

.tooltip[x-placement^='top'] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='bottom'] {
  margin-top: 5px;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='right'] {
  margin-left: 5px;
}

.tooltip[x-placement^='right'] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^='left'] {
  margin-right: 5px;
}

.tooltip[x-placement^='left'] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  @include border-radius(5px);

  background: #f9f9f9;
  color: black;
  padding: 24px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  @include transition(opacity 0.15s, visibility 0.15s);
  @include opacity(0);

  visibility: hidden;
}

.tooltip[aria-hidden='false'] {
  @include transition(opacity 0.15s);
  @include opacity(1);

  visibility: visible;
}

.underline {
  text-decoration: underline;
}
</style>
